import React, { useState, useEffect, useContext, createContext} from 'react';
import '../view-archer-styles.css';

// material-ui
import { Box, Grid} from '@mui/material/';
import { styled } from '@mui/material/styles';

//components import
import FilerListSideBar from './FilerListSidebar';
import FilerSummary from './FilerSummary';
import ReferralManager from './ReferralManager';
import Audit205ScheduleManager from './Audit205ScheduleManager';
import { AuditorCommunicationContext } from '../view-archer';
import ArcherIssueGalleryTemplate from '../dataObjects/ArcherIssueGalleryTemplate';

interface Props {
    searchInput: string;
    displayStatus: string;
    filerSummaryDisplayStatus: string;
    referralDisplayStatus: string;
    audit205DisplayStatus: string;
}

export interface FilerCommunication {
    currentCpfId: number;
    setCurrentCpfId: (newId: number) => void;
}

export const FilerCommunicationContext = createContext<FilerCommunication>({
    currentCpfId: 17983,
    setCurrentCpfId: () => { }
});


const FilersRoot = (props: Props) => {

    useEffect(() => {
        getIssueTemplates();
    }, []);

    const Item = styled(Box)(({ theme }) => ({
        ...theme.typography.body2,
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    }));


    //initial state setup
    const [currentCpfId, setCurrentCpfId] = useState(0);
    const [isPayloadUpdated, setPayloadUpdated] = useState(false);

    const [filerSummaryDisplayStatus, setFilerSummaryDisplayStatus] = useState(props.filerSummaryDisplayStatus);
    const [referralManagerDisplayStatus, setReferralManagerDisplayStatus] = useState(props.referralDisplayStatus);
    const [audit205DisplayStatus, setAudit205DisplayStatus] = useState(props.audit205DisplayStatus);

    const setDefaultCpfId = (cpfId: number) => {
        if (filerSummaryDisplayStatus === "active") {
            setCurrentCpfId(cpfId);
        }
    }

    const auditorIdContext = useContext(AuditorCommunicationContext);

    const updateAuditorId = (auditorId: number) => {
        auditorIdContext.currentAuditorId = auditorId;
    }

    const [issueTemplates, setIssueTemplates] = useState<ArcherIssueGalleryTemplate[]>();

    const getIssueTemplates = async () => {
        let url = `/Archer3/GetGalleryItems`;
        await fetch(url)
            .then(result => result.json())
            .then(result => {
                let templates = result.result;
                setIssueTemplates(templates);
            })
    }

    return (
        <div className={`filers ${props.displayStatus}`}>
            <FilerCommunicationContext.Provider value={{
                currentCpfId: currentCpfId,
                setCurrentCpfId: (newId: number) => {
                    setCurrentCpfId(newId);
                    setPayloadUpdated(!isPayloadUpdated);
                    setFilerSummaryDisplayStatus('active');
                    setReferralManagerDisplayStatus('hidden');
                    setAudit205DisplayStatus('hidden');
                }
            }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid item xs={2.3} sx={{ bgcolor: '#fafafa' }}>
                            <FilerListSideBar searchInput={props.searchInput} setDefaultCpfId={setDefaultCpfId} updateAuditorId={updateAuditorId} auditorId={auditorIdContext.currentAuditorId}></FilerListSideBar>
                        </Grid>
                        <Grid item className={filerSummaryDisplayStatus} xs={9.5} sx={{ paddingLeft: 0, paddingTop: 0 }} >
                            <Item><FilerSummary isPayloadUpdated={isPayloadUpdated} issueTemplates={issueTemplates} displayStatus={filerSummaryDisplayStatus}></FilerSummary></Item>
                        </Grid>
                        <Grid item className={referralManagerDisplayStatus} xs={9.5} sx={{ paddingLeft: 0, paddingTop: 0 }} >
                            <Item><ReferralManager displayStatus={referralManagerDisplayStatus} auditorId={auditorIdContext.currentAuditorId}></ReferralManager></Item>
                        </Grid>
                        <Grid item className={audit205DisplayStatus} xs={9.5} sx={{ paddingLeft: 0, paddingTop: 0 }} >
                            <Item><Audit205ScheduleManager displayStatus={audit205DisplayStatus} auditorId={auditorIdContext.currentAuditorId}></Audit205ScheduleManager></Item>
                        </Grid>
                    </Grid>
                </Box>
            </FilerCommunicationContext.Provider>
        </div>
    )
}

export default FilersRoot;